import { Link } from 'react-router-dom';
import { Container } from '@/components/ui/Container';

const footerLinks = {
  product: [
    { name: 'Overview', href: '/product' },
    { name: 'Work Orders', href: '/work-orders' },
    { name: 'For Pumpers', href: '/pumpers' },
    { name: 'For Operators', href: '/operators' },
    { name: 'Pricing', href: '/pricing' },
  ],
  company: [
    { name: 'Security', href: '/security' },
    { name: 'Contact', href: '/contact' },
  ],
  legal: [
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Terms of Service', href: '/terms' },
  ],
};

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="border-t border-hairline bg-roughneck-950">
      <Container>
        <div className="pb-12 pt-20 lg:pb-16 lg:pt-28">
          <div className="grid grid-cols-2 gap-8 lg:grid-cols-4">
            {/* Brand Column */}
            <div className="col-span-2 lg:col-span-1">
              <Link to="/" className="inline-block">
                <img
                  src="/logo-wordmark.svg"
                  alt="Roughneck"
                  className="h-[18px] w-auto"
                />
              </Link>
              <p className="mt-4 text-sm text-roughneck-400">
                Field-first work orders and well operations for oil & gas operators and pumpers.
              </p>
              <div className="mt-6 flex gap-4">
                <a
                  href="https://linkedin.com/company/roughneck-io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-roughneck-400 transition-colors hover:text-white"
                  aria-label="LinkedIn"
                >
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" />
                  </svg>
                </a>
                <a
                  href="https://twitter.com/roughneck_io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-roughneck-400 transition-colors hover:text-white"
                  aria-label="Twitter"
                >
                  <svg className="h-5 w-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
                  </svg>
                </a>
              </div>
            </div>

            {/* Product Links */}
            <div>
              <h3 className="eyebrow">Product</h3>
              <ul className="mt-4 space-y-3">
                {footerLinks.product.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-roughneck-400 transition-colors hover:text-white"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company Links */}
            <div>
              <h3 className="eyebrow">Company</h3>
              <ul className="mt-4 space-y-3">
                {footerLinks.company.map((link) => (
                  <li key={link.name}>
                    <Link
                      to={link.href}
                      className="text-sm text-roughneck-400 transition-colors hover:text-white"
                    >
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="eyebrow">Contact</h3>
              <ul className="mt-4 space-y-3 font-mono text-sm text-roughneck-400">
                <li>
                  <a href="mailto:hello@roughneck.io" className="transition-colors hover:text-white">
                    hello@roughneck.io
                  </a>
                </li>
              </ul>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="mt-16 flex flex-col items-center justify-between gap-4 border-t border-hairline pt-8 sm:flex-row">
            <p className="font-mono text-xs tracking-eyebrow text-roughneck-500">
              &copy; {currentYear} ROUGHNECK. ALL RIGHTS RESERVED.
            </p>
            <div className="flex gap-6">
              {footerLinks.legal.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  className="font-mono text-xs tracking-eyebrow text-roughneck-500 transition-colors hover:text-roughneck-300"
                >
                  {link.name}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </Container>
    </footer>
  );
}
